// extracted by mini-css-extract-plugin
module.exports = {"drawer":"release-drawer-module--drawer--o5yKz","closeButton":"release-drawer-module--closeButton--1-JNx","drawerContent":"release-drawer-module--drawerContent--21Z3N"};